// extracted by mini-css-extract-plugin
module.exports = {"form_wrapper":"form_form_wrapper__5oqEc","form_title_wrapper":"form_form_title_wrapper__SYdpa"};